import { ContactsService, InitContactDialogInput } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type ContactsCheckExistContactDialogInputVariables = {
  requestBody?: InitContactDialogInput;
};
export const useContactsCheckExistContactDialogQuery = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof ContactsService.postContactsCheckExistContactDialog>>,
      QueryError,
      ContactsCheckExistContactDialogInputVariables,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ requestBody }: ContactsCheckExistContactDialogInputVariables) =>
      ContactsService.postContactsCheckExistContactDialog(requestBody),
    {
      ...options,
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
